import React from "react";
import { ArrowRightLeft } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { SectionToggle, NumInput } from "./shared";

const DEFAULT_RC = { enabled: true, annual_amount: 20000, start_age: 60, end_age: 70, tax_rate: 22 };

export default function RothConversionSection({ inputs, setInputs, open, onToggle }) {
  const rcOn = inputs.roth_conversion?.enabled;
  const taxOn = inputs.tax_config?.enabled;
  const updateRC = (k, v) => setInputs({ ...inputs, roth_conversion: { ...inputs.roth_conversion, [k]: v } });
  const toggleRC = (v) => {
    if (v && !inputs.roth_conversion) setInputs({ ...inputs, roth_conversion: { ...DEFAULT_RC } });
    else if (v) updateRC("enabled", true);
    else updateRC("enabled", false);
  };

  return (
    <div>
      <SectionToggle
        testId="toggle-roth"
        icon={ArrowRightLeft}
        title="Roth conversion ladder"
        subtitle="Move 401k → Roth in low-income years"
        badge={rcOn ? "on" : "off"}
        open={open}
        onToggle={onToggle}
      />
      {open && (
        <div className="pb-5 space-y-4">
          <div className="flex items-center justify-between text-sm">
            <Label className="text-[#1C2B23]">Enable Roth conversions</Label>
            <Switch data-testid="rc-enabled" checked={!!rcOn} onCheckedChange={toggleRC} />
          </div>
          {rcOn && (
            <>
              <NumInput id="rc-amt" testid="rc-annual-amount" label="Annual conversion amount" value={inputs.roth_conversion.annual_amount} onChange={(v) => updateRC("annual_amount", v)} prefix="$" step={1000} />
              <div className="grid grid-cols-3 gap-3">
                <NumInput id="rc-start" testid="rc-start-age" label="Start age" value={inputs.roth_conversion.start_age} onChange={(v) => updateRC("start_age", v)} suffix="yrs" />
                <NumInput id="rc-end" testid="rc-end-age" label="End age" value={inputs.roth_conversion.end_age} onChange={(v) => updateRC("end_age", v)} suffix="yrs" />
                <NumInput id="rc-tax" testid="rc-tax-rate" label="Conversion tax" value={inputs.roth_conversion.tax_rate} onChange={(v) => updateRC("tax_rate", v)} suffix="%" step={1} />
              </div>
              <p className="text-[11px] text-[#5C6B62] leading-relaxed">
                Each conversion year: move funds from Tax-deferred → Roth and pay {inputs.roth_conversion.tax_rate}% tax from your taxable account. Only effective when tax-aware accounts are enabled.
              </p>
              {!taxOn && (
                <p className="text-[11px] text-[#C26747]">Tip: turn on tax-aware accounts above for this to take effect.</p>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
